import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export const SlugRedirect = () => {
  const { eventSlug } = useParams();

  // Redirect /:eventSlug to /event/:eventSlug
  return <Navigate to={`/event/${eventSlug}`} replace />;
};
